import React from 'react';
import './Link.scss';

const Link = (props, ref) => {

    const classes = 'Link ' + props.className;
    const href = props.href
    const content = props.content
    const target = '_blank' || props.target;
    const onClick = props.onClick;
    


    return (
        <a onClick={onClick} ref={ref} href={href} className={classes} target={target}>
            {content}
        </a>
    );
};


const forwardRefLink = React.forwardRef(Link)
export default forwardRefLink;
